import * as yup from 'yup';

import { phoneNumberReg } from '@/lib/regex/personal-info';

export const applyRefundPhoneNumberFormSchema = yup
  .object({
    phone: yup
      .string()
      .length(phoneNumberReg.minLength, phoneNumberReg.requiredMessage)
      .matches(phoneNumberReg.regExp, phoneNumberReg.requiredMessage)
      .required(phoneNumberReg.requiredMessage)
  })
  .required();
